export default {"allSportsMenu":"jRFNt","content":"bzsKo","header":"_2LuYM","open":"TfJdW","fullHeight":"mC2BD"};